import { Injectable } from "@angular/core";
import { HttpHeaders, HttpClient } from "@angular/common/http";
import { MatSnackBar } from "@angular/material/snack-bar";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { RestApi } from "src/app/shared/RestApi/restApi";
import { Router } from '@angular/router';
import { Observable } from 'rxjs';


interface elasticsearchInfo {
  statusMessage: any;
  error: boolean;
  data: any;
}

@Injectable({
  providedIn: 'root'
})
export class ElasticserviceService {
  private headers = new HttpHeaders({ "Content-Type": "application/json" });

  constructor(
    private http: HttpClient,
    private snackBar: MatSnackBar,
    private spinner: NgxUiLoaderService,
    private restAPI: RestApi,
    private router: Router) { }

    retrievelasticService(from,size,filters) {

      this.spinner.start();
      if(filters == "" || filters == undefined){
        console.log("no filters")
        return this.http.get<elasticsearchInfo>(this.restAPI.GET_ELASTIC_SEARCH_DATA+"/"+from+"/"+size, { headers: this.headers })
      }else{
      return this.http.get<elasticsearchInfo>(this.restAPI.GET_ELASTIC_SEARCH_FILTER_DATA+"/"+from+"/"+size+"/"+filters, { headers: this.headers })
      }
    }

    // retrievelasticFilterService(from,size,filters) {

    //   this.spinner.start();
  
    //   return this.http.get<elasticsearchInfo>(this.restAPI.GET_ELASTIC_SEARCH_FILTER_DATA+"/"+from+"/"+size+"/"+filters, { headers: this.headers })
    // }
    
}
